import { useQuery } from '@tanstack/react-query';
import { Select, type SelectProps } from 'antd';
import { getSalaryGradesDropdown } from 'src/apis/master_data/salaryGrade.api';

export default function SalaryGradeSelect({ value, onChange, style, allowClear, ...props }: SelectProps) {
  const salaryGradesDropdownQuery = useQuery({
    queryKey: ['salaryGradesDropdown'],
    queryFn: () => getSalaryGradesDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      allowClear={allowClear}
      value={salaryGradesDropdownQuery.isFetching ? undefined : value}
      style={style}
      onChange={onChange}
      options={salaryGradesDropdownQuery.data?.data.map((item) => ({
        value: item.id,
        label: item.name,
        salaryGrade: item
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={salaryGradesDropdownQuery.isFetching}
      {...props}
    />
  );
}
